module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section nav-wrap"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("设置")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "导航设置"
    }
  }, [_c('draggable', {
    staticClass: "content-bottom-padded",
    attrs: {
      "options": _vm.dragItemsOptions
    },
    on: {
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.t_data.data),
      callback: function($$v) {
        _vm.$set(_vm.t_data, "data", $$v)
      },
      expression: "t_data.data"
    }
  }, _vm._l((_vm.t_data.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setting-item item-selected"
    }, [_c('el-input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "placeholder": "请输入导航名",
        "size": "small"
      },
      model: {
        value: (item.tab),
        callback: function($$v) {
          _vm.$set(item, "tab", $$v)
        },
        expression: "item.tab"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "goods-title",
      on: {
        "click": function($event) {
          return _vm.editLink(index)
        }
      }
    }, [(item.linkPage === 'goods') ? [_vm._v("【商品】" + _vm._s(item.title))] : _vm._e(), _vm._v(" "), (item.linkPage === 'store') ? [_vm._v("【店铺】" + _vm._s(item.title))] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "setting-remove",
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt"
    })])], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "iconfont icon-cog banner-button-uploader",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.setNav
    }
  }, [_vm._v("设置导航")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("( 导航说明：导航菜单数量限制为8，不过建议根据实际菜单名称的长度，选择性显示导航菜单数量。)")])], 1)], 1), _vm._v(" "), _c('linkSetter', {
    attrs: {
      "links": _vm.linksArr,
      "usage": "pc",
      "visible": _vm.linksVisible,
      "show_article": false,
      "show_planting": false,
      "show_page": false,
      "show_marketing": false,
      "show_category": false,
      "show_store": _vm.show_store
    },
    on: {
      "setLink": _vm.setLink,
      "closeDialog": _vm.closeDialog
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f0032156", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0032156"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/homePage/components/plugins/nav/style.vue
// module id = 2974
// module chunks = 0